<template>
  <form @submit.prevent="handleSubmit(item)">
    <b-row>
      <b-col>
        <div class="form-group">
          <label
                  for="excmagreementsla_sla"
                  class="form-control-label">{{ $t('views.excmagreementssla.form.sla') }}:</label>
          <fg-input>
            <el-select
                    id="excmagreementsla_sla"
                    class="select-default"
                    :placeholder="$t('views.excmagreementssla.form.sla')"
                    filterable
                    v-model="item.sla">
              <el-option v-for="option in slasOptions"
                         class="select-default"
                         :value="option['@id']"
                         :label="option.title"
                         :key="option['@id']">
              </el-option>
            </el-select>
          </fg-input>
          <div
                  v-if="isInvalid('sla')"
                  class="invalid-feedback">{{ violations.sla }}</div>
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <button type="submit" class="btn btn-success">{{ $t('buttons.submit') }}</button>
        <b-btn variant="danger" @click="closeModal()">{{ $t('buttons.cancel') }}</b-btn>
      </b-col>
    </b-row>
  </form>
</template>

<script>
export default {
  props: {
    handleSubmit: {
      type: Function,
      required: true
    },

    type: {
      type: Number,
      default: 0
    },

    handleUpdateField: {
      type: Function,
      required: true
    },

    values: {
      type: Object,
      required: true
    },

    errors: {
      type: Object,
      default: () => {}
    },

    initialValues: {
      type: Object,
      default: () => {}
    }
  },

  data () {
    return {
      slasOptions: []
    }
  },

  created () {
    this.getSlas()
    this.channelSlas = this.$store.state.Pusher.subscribe('e_x_c_m_slas')
    this.channelSlas.bind('e_x_c_m_slas', data => {
      this.getSlas()
    })
  },

  computed: {
    // eslint-disable-next-line
    item () {
      return this.initialValues || this.values
    },

    violations () {
      return this.errors || {}
    }
  },

  methods: {
    getSlas () {
      this.slasOptions = []
      let params = {
        'pagination': false
      }
      this.devicesOptions = []
      this.$http.get('api/e_x_c_m_slas', {
        params
      })
        .then(response => {
          this.slasOptions = response.data['hydra:member']
        })
        .catch(error => {
          if (error.response.status === 400) {
            let text = ''
            for (let i in error.response.data) {
              text += error.response.data[i] + '\n'
            }
            this.$Swal({
              type: 'warning',
              title: text,
              timer: 2500
            })
          }
          console.log(error)
        })
    },
    closeModal () {
      if (this.type === 1) {
        this.$store.state.modals.excmagreementsla.create.close = 1
      } else if (this.type === 2) {
        this.$store.state.modals.excmagreementsla.update.close = 1
      }
    },
    isInvalid (key) {
      return Object.keys(this.violations).length > 0 && this.violations[key]
    }
  }
}
</script>
